import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  tooltipContent: {
    background: 'rgb(255, 255, 255, 0.8)',
    border: 1,
    padding: 2,
    fontSize: 14,
    width: 200,
    textAlign: 'left',
    paddingLeft: 20
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  headline: {
    color: 'pink'
  },
  headlineAsset: {
    color: 'lightgreen'
  },
  display1: {
    color: 'lightgrey',
    textAlign: 'left',
    padding: '30px'
  }
})

const axis = {
  orient: 'left',
  tickFormat: d => (
    <text
      key={`tick-${d}`}
      style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
      y={-2}
      x={6}
    >
      {d / 1000}K
    </text>
  ),
  tickValues: [1000, 2000, 3000, 4000, 5000, 6000, 7000],
  baseline: false,
  tickLineGenerator: ({ xy }) => (
    <path
      key={`tickLine-${xy.value}`}
      style={{ stroke: '#F0F0F0 ' }}
      d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${xy.y1}L${xy.x1},${
        xy.y1
      }Z`}
    />
  )
}

const exampleAnnotations = [
  {
    AmountC: 600,
    type: 'r',
    offset: 0,
    dy: 0,
    dx: -20,
    connector: { end: 'none' },
    color: 'rgba(106, 106, 106, 0.25)',
    label: '$600',
    eventListeners: {}
  }
]

@withStyles(styles)
export default class FinaChartSpentFood extends Component {
  render() {
    const { classes } = this.props
    const data = this.props.chart
      ? JSON.parse(this.props.chart.dataSetNew.dataPoints)
      : JSON.parse(this.props.data)

    return (
      <OrdinalFrame
        size={[this.props.width, this.props.height]}
        data={data}
        axis={axis}
        rExtent={[0, undefined]}
        oExtent={{
          onChange: d => {
            this.setState({ oExtent: d })
          }
        }}
        projection={'vertical'}
        type={{
          type: 'bar',
          customMark: d => (
            <rect
              key={`mark-${d.renderKey}`}
              fill={
                d.SpendType === 'Eat Out'
                  ? 'orange'
                  : d.SpendType === 'Grocery' ? 'purple' : 'black'
              }
              opacity={0.3}
              width={
                this.props.width *
                (1 - 1 / 15.5 - 1 / 12.6 - 6 / 22 - 1 / 30) /
                7
              }
              height={d.scaledValue}
              rx={3}
              ry={3}
            />
          )
        }}
        oLabel={d =>
          d === moment().format('MMM YY') ? (
            <text
              key={`label-${d}`}
              y={2}
              fill="#62c71f"
              textAnchor="middle"
              fontSize={12}
            >
              {d}
            </text>
          ) : (
            <text
              key={`label-${d}`}
              y={2}
              fill="#9BA4A5"
              textAnchor="middle"
              fontSize={12}
            >
              {d}
            </text>
          )
        }
        oPadding={this.props.width / 22}
        oAccessor={d => moment(new Date(d.Date)).format('MMM YY')}
        rAccessor={d => d.AmountC}
        sortO={(a, b) => a < b}
        style={d => {
          return { fill: 'green' }
        }}
        hoverAnnotation={true}
        annotationSettings={{
          layout: {
            type: 'marginalia',
            orient: 'right',
            textPadding: this.props.width / 21
          }
        }}
        connectorStyle={d => {
          return {
            fill:
              d.source.SpendType === 'Eat Out'
                ? 'orange'
                : d.source.SpendType === 'Grocery' ? 'purple' : 'black',
            opacity: 0.18
          }
        }}
        margin={{
          left: this.props.width / 15.5,
          top: this.props.height / 24,
          right: this.props.width / 12.6,
          bottom: this.props.height / 9.6
        }}
        annotations={exampleAnnotations}
        tooltipContent={d => {
          let total = 0
          d.pieces.forEach(p => {
            total = total + parseFloat(p.AmountC)
          })
          return (
            <div key={`tooltip-${d.pieces[0].renderKey}`}>
              <div
                className={classes.tooltipContent}
                key={`tooltip${d.pieces[0].renderKey}`}
              >
                <b>
                  {moment(new Date(d.pieces[0].Date)).format('MMM YY')} Total:{' '}
                  {total.toFixed(0)}{' '}
                </b>
                <br />
              </div>
              {d.pieces.map((piece, index) => (
                <div
                  className={classes.tooltipContent}
                  key={`item-${piece.Date}-${piece.SpendType}`}
                >
                  <span
                    style={{
                      color:
                        piece.SpendType === 'Eat Out'
                          ? 'orange'
                          : piece.SpendType === 'Grocery' ? 'purple' : 'black'
                    }}
                  >
                    {piece.SpendType}
                  </span>: {parseFloat(piece.AmountC).toFixed(0)}
                </div>
              ))}
            </div>
          )
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/FinaChartSpentFood.js